const ClaimCheckBanner = () => {
  return (
    <>
      <section>
        <div className="flex min-h-[300px] flex-col sm:min-h-[350px] lg:min-h-[300px] lg:flex-row">
          {/* Photo - Left Side */}
          <div className="relative order-1 h-80 sm:h-96 lg:order-1 lg:h-auto lg:w-1/2">
            <img
              src="/Image/Claims1-car-finance-claim-uk.webp"
              alt="Car finance claim - Your Claim Matters services"
              className="h-full w-full object-cover"
              fetchPriority="high"
            />
          </div>

          {/* Text - Right Side */}
          <div
            className="order-2 flex h-80 items-center justify-center px-4 py-8 sm:h-96 sm:px-6 sm:py-10 lg:order-2 lg:h-auto lg:w-1/2 lg:px-20 lg:py-12"
            style={{ backgroundColor: '#095678' }}
          >
            <div className="max-w-2xl text-center sm:text-left">
              <h2 className="font-raleway-numbers text-2xl leading-tight font-bold text-white sm:text-3xl lg:text-4xl">
                See whether you may be eligible to make a claim. It only takes
                60 seconds to check if you&apos;re a victim of vehicle finance
                mis-selling with our online eligibility checker.
              </h2>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ClaimCheckBanner
